import cn from 'classnames';
import * as React from 'react';

import { useSpacingCtx } from '../../context';

import styles from './SpacingRowItem.module.scss';

export enum SpacingRowItemSize {
  notSet = 'not-set',

  /** 100% */
  full = 'full',

  /** 50% */
  half = 'half',

  /** 33.3% */
  third = 'third',

  /** 25% */
  quarter = 'quarter',
}

export type SpacingRowItemProps = React.HTMLProps<HTMLDivElement> & {
  itemSize?: SpacingRowItemSize;
  grow?: boolean;
  shrink?: false;
  minContent?: boolean;
};

const SpacingRowItem: React.FC<SpacingRowItemProps> = ({
  itemSize = SpacingRowItemSize.notSet,
  grow,
  shrink,
  minContent,
  className,
  ...p
}: SpacingRowItemProps) => {
  const { vSpacing, hSpacing } = useSpacingCtx();

  return (
    <div
      {...p}
      className={cn(
        className,
        styles['row-item'],
        grow && styles['row-item_size-grow'],
        shrink === false && styles['row-item_shrink_false'],
        minContent && styles['row-item_size-min-content'],
        itemSize &&
          itemSize !== SpacingRowItemSize.notSet &&
          styles[`row-item_size-${itemSize}`],
        styles[`row-item_spacing-v-${vSpacing}`],
        styles[`row-item_spacing-h-${hSpacing}`]
      )}
    />
  );
};

SpacingRowItem.displayName = 'Spacing.RowItem';

export default SpacingRowItem;
